import { BdsIconArrowUUpLeft } from "@buildertrend/components";

import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "history";
const onClick = (editor: IEditor) => {
    editor.tiptapEditor.commands.undo();
};

export const undoControl: ICollapsableControl = {
    key: "undo",
    isControlSupported(supportedExtensions, editor) {
        return (
            supportedExtensions.has(extensionId) && editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return tiptapEditor.can().undo();
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                data-testid="undo"
                icon={<BdsIconArrowUUpLeft />}
                isToggled={false}
                onClick={() => onClick(editor)}
                disabled={!editor.tiptapEditor.can().undo()}
                friendlyName="Undo"
            />
        );
    },
    collapsedActiveKeys() {
        return [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                key={this.key}
                menuProps={{
                    icon: <BdsIconArrowUUpLeft />,
                    onClick: () => onClick(editor),
                    disabled: !editor.tiptapEditor.can().undo(),
                    testid: "undo",
                }}
            >
                Undo
            </InputRecaptureHackMenuItem>
        );
    },
};
